import type { TabLink } from './types'

/**
 * Whether two tab links point at the same thing. A tab is identified by what it
 * navigates to, so transient state such as `isActive` or `isDraft` is ignored.
 */
export const isSameTabTarget = (tabLink: TabLink, other: TabLink) =>
  tabLink.id === other.id &&
  tabLink.layer.tenantId === other.layer.tenantId &&
  tabLink.layer.layerId === other.layer.layerId &&
  tabLink.block === other.block &&
  tabLink.variant === other.variant
